import * as mutypes from "@/store/mutation.types";
import api from '/src/api/api';

const emptyPagination = () => ({ currentPage: 1, perPage: 15, total: 0 })

/**
 * Списки приходят стандартной пагинацией Laravel: { data, links, meta }
 */
const extractPagination = (responseData, fallbackPerPage) => ({
    currentPage: responseData?.meta?.current_page ?? 1,
    perPage: responseData?.meta?.per_page ?? fallbackPerPage,
    total: responseData?.meta?.total ?? 0,
})

export default {
    namespaced: true,
    state: () => ({
        giveaways: [],
        currentGiveaway: null,
        coupons: [],
        winners: [],
        pagination: emptyPagination(),
        couponsPagination: { ...emptyPagination(), perPage: 50 },
        winnersPagination: { ...emptyPagination(), perPage: 50 },
    }),

    mutations: {
        [mutypes.SET_GIVEAWAYS]: (state, giveaways) => state.giveaways = giveaways,
        [mutypes.SET_CURRENT_GIVEAWAY]: (state, giveaway) => state.currentGiveaway = giveaway,
        [mutypes.SET_GIVEAWAYS_PAGINATION]: (state, pagination) => state.pagination = pagination,
        [mutypes.SET_GIVEAWAY_COUPONS]: (state, coupons) => state.coupons = coupons,
        [mutypes.SET_GIVEAWAY_COUPONS_PAGINATION]: (state, pagination) => state.couponsPagination = pagination,
        [mutypes.SET_GIVEAWAY_WINNERS]: (state, winners) => state.winners = winners,
        [mutypes.SET_GIVEAWAY_WINNERS_PAGINATION]: (state, pagination) => state.winnersPagination = pagination,
        [mutypes.UPDATE_GIVEAWAY_WINNER]: (state, winner) => {
            const index = state.winners.findIndex(item => item.id === winner.id)
            if (index !== -1) state.winners.splice(index, 1, winner)
        },
        [mutypes.UPDATE_GIVEAWAY_COUPON]: (state, coupon) => {
            const index = state.coupons.findIndex(item => item.id === coupon.id)
            if (index !== -1) state.coupons.splice(index, 1, {...state.coupons[index], ...coupon})
        },
    },

    actions: {
        async fetchGiveaways({ commit, state }, params = {}) {
            const response = await api.giveaways.index({ per_page: state.pagination.perPage, ...params })
            commit(mutypes.SET_GIVEAWAYS, response.data.data)
            commit(mutypes.SET_GIVEAWAYS_PAGINATION, extractPagination(response.data, state.pagination.perPage))
            return response
        },

        async fetchGiveaway({ commit }, id) {
            const response = await api.giveaways.show(id)
            commit(mutypes.SET_CURRENT_GIVEAWAY, response.data.data)
            return response
        },

        async createGiveaway(context, giveawayData) {
            return await api.giveaways.store(giveawayData)
        },

        async updateGiveaway(context, { id, giveawayData }) {
            return await api.giveaways.update(id, giveawayData)
        },

        async deleteGiveaway(context, id) {
            return await api.giveaways.delete(id)
        },

        async fetchGiveawayCoupons({ commit, state }, { id, params = {} }) {
            const response = await api.giveaways.coupons(id, { per_page: state.couponsPagination.perPage, ...params })
            commit(mutypes.SET_GIVEAWAY_COUPONS, response.data.data)
            commit(mutypes.SET_GIVEAWAY_COUPONS_PAGINATION, extractPagination(response.data, state.couponsPagination.perPage))
            return response
        },

        async fetchGiveawayWinners({ commit, state }, { id, params = {} }) {
            const response = await api.giveaways.winners(id, { per_page: state.winnersPagination.perPage, ...params })
            commit(mutypes.SET_GIVEAWAY_WINNERS, response.data.data)
            commit(mutypes.SET_GIVEAWAY_WINNERS_PAGINATION, extractPagination(response.data, state.winnersPagination.perPage))
            return response
        },

        async updateWinnerRewardStatus({ commit }, { id, winnerId, rewardStatus }) {
            const response = await api.giveaways.updateWinnerRewardStatus(id, winnerId, rewardStatus)
            commit(mutypes.UPDATE_GIVEAWAY_WINNER, response.data.data)
            return response
        },

        async updateCouponDescription({ commit }, { id, couponId, description }) {
            const response = await api.giveaways.updateCouponDescription(id, couponId, description)
            commit(mutypes.UPDATE_GIVEAWAY_COUPON, {...response.data?.data, id: couponId, description})
            return response
        },
    },

    getters: {
        getGiveaways: state => state.giveaways,
        getCurrentGiveaway: state => state.currentGiveaway,
        getGiveawaysPagination: state => state.pagination,
        getGiveawayCoupons: state => state.coupons,
        getGiveawayCouponsPagination: state => state.couponsPagination,
        getGiveawayWinners: state => state.winners,
        getGiveawayWinnersPagination: state => state.winnersPagination,
    },
};
